import { ResizeAPI } from '@wix/thumbnail-generator';
import { isEditorX } from '../../utils/editorx';
export var defaultSettings = {
  apiUrl: isEditorX ? 'https://files.editorx.com' : 'https://files.wix.com',
  imageOperationsApi: ResizeAPI.Vanbrandt,
  filesUrl: 'https://static.wixstatic.com',
  videoFilesUrl: 'https://video.wixstatic.com',
  refreshTokenUrl: null,
  requestOptions: {
    withCredentials: true
  },
  uploadLimits: {
    "default": 15728640,
    document: 15728640,
    picture: 15728640,
    music: 52428800,
    secureMusic: 377487360,
    video: 524288000,
    secureVideo: 1610612736
  },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  blackArrow: {
    wsUrl: 'wss://ws.wixmp.com/ws',
    messageUrl: 'https://ws.wixmp.com/message',
    tokenUrl: '/users/get-batoken',
    disabled: false
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};